import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=7adfd81f&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfd81f",
  null
  
)

export default component.exports